import { render, staticRenderFns } from "./HaiBao.vue?vue&type=template&id=4bf80e53"
import script from "./HaiBao.vue?vue&type=script&lang=js"
export * from "./HaiBao.vue?vue&type=script&lang=js"
import style0 from "./HaiBao.vue?vue&type=style&index=0&id=4bf80e53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports